import { Sequence } from "remotion";
import { Stage } from "../../coldcompute";
import { SCENE } from "./constants";
import {
  Scene01Hook,
  Scene02Strawman,
  Scene03Ast,
  Scene04Rrf,
  Scene05Router,
  Scene06Cache,
  Scene07Maturity,
  Scene08Gate,
  Scene09Recency,
  Scene10Pipeline,
  Scene11Close,
} from "./scenes";

/**
 * FLAGSHIP — "Why Naive RAG Fails in Production (And How Grounded Hybrid
 * Retrieval Actually Works)". A problem-first production postmortem: each layer
 * scene shows the failure it kills, then the mechanism. ~6:58 @ 30fps
 * (re-timed 2026-07-12 from the original 16:00; on-screen captions removed —
 * see flagship-naive-rag-fails.srt for the caption/VO script). VO track still TODO.
 *
 * Register in Root.tsx with:
 *   id="FlagshipNaiveRagFails", durationInFrames={TOTAL_DURATION},
 *   fps=30, width=1920, height=1080.
 * (The operator wires Root.tsx — do NOT edit it here.)
 */
export const FlagshipNaiveRagFails: React.FC = () => (
  <Stage>
    <Sequence from={SCENE.hook.start} durationInFrames={SCENE.hook.duration}>
      <Scene01Hook />
    </Sequence>
    <Sequence from={SCENE.strawman.start} durationInFrames={SCENE.strawman.duration}>
      <Scene02Strawman />
    </Sequence>
    <Sequence from={SCENE.astChunking.start} durationInFrames={SCENE.astChunking.duration}>
      <Scene03Ast />
    </Sequence>
    <Sequence from={SCENE.rrf.start} durationInFrames={SCENE.rrf.duration}>
      <Scene04Rrf />
    </Sequence>
    <Sequence from={SCENE.router.start} durationInFrames={SCENE.router.duration}>
      <Scene05Router />
    </Sequence>
    <Sequence from={SCENE.cache.start} durationInFrames={SCENE.cache.duration}>
      <Scene06Cache />
    </Sequence>
    <Sequence from={SCENE.maturity.start} durationInFrames={SCENE.maturity.duration}>
      <Scene07Maturity />
    </Sequence>
    <Sequence from={SCENE.outputGate.start} durationInFrames={SCENE.outputGate.duration}>
      <Scene08Gate />
    </Sequence>
    <Sequence from={SCENE.recency.start} durationInFrames={SCENE.recency.duration}>
      <Scene09Recency />
    </Sequence>
    <Sequence from={SCENE.pipeline.start} durationInFrames={SCENE.pipeline.duration}>
      <Scene10Pipeline />
    </Sequence>
    <Sequence from={SCENE.close.start} durationInFrames={SCENE.close.duration}>
      <Scene11Close />
    </Sequence>
    {/* <Audio src={staticFile("vo/flagship-naive-rag-fails.mp3")} /> — add the VO track here later */}
  </Stage>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
